import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { getRole } from "../../helpers/ReduxHelpers";

const SessionTimer = () => {
  const userInfo = useSelector((state) => state.user.userInfo);
  
  useEffect(() => {
    const start = Date.now();

    const handleUnload = () => {
      const end = Date.now();
      const durationSec = Math.floor((end - start) / 1000);

      // Get user context for session event
      const getUserContext = () => {
        if (!userInfo?.id) return {};
        
        const roles = getRole();
        return {
          user_name: userInfo?.merchant?.name || 'Unknown',
          user_role: roles.join(', ') || 'Unknown',
          primary_role: roles[0] || 'Unknown',
          merchant_id: userInfo?.merchant?.id || 'Unknown'
        };
      };

      const userContext = getUserContext();

      ReactGA.gtag('event', 'session_duration', {
        event_category: 'Session',
        event_label: 'Session End',
        value: durationSec,
        session_duration_seconds: durationSec,
        session_start_time: start,
        session_end_time: end,
        ...userContext
      });
      
      console.log('Sent session_duration event with custom parameters using gtag:', {
        durationSec,
        userContext
      });
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [userInfo?.id, userInfo?.merchant?.name, userInfo?.merchant?.id]);

  return null;
};

export default SessionTimer;
